import React from 'react';
import { MessageCircle, MapPin, Clock, Phone, Instagram, Heart } from 'lucide-react';
import { restaurantInfo, logoUrl } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const quickLinks = [
    { label: 'Cardápio', href: restaurantInfo.menuUrl, external: true },
    { label: 'Delivery', href: restaurantInfo.deliveryUrl, external: true },
    { label: 'Galeria', href: '#galeria', external: false },
    { label: 'Localização', href: '#localizacao', external: false },
    { label: 'Horários', href: '#horarios', external: false },
  ];

  const handleNavClick = (e, href, external) => {
    if (external) {
      window.open(href, '_blank');
    } else {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-neutral-950 pt-16 pb-8" role="contentinfo">
      <div className="container mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="#" className="inline-block mb-6" aria-label="Japamix - Página inicial">
              <img 
                src={logoUrl} 
                alt="Logo Japamix restaurante japonês Anápolis" 
                className="h-16 w-auto object-contain"
              />
            </a>
            <p className="text-white/60 leading-relaxed mb-6">
              O melhor restaurante japonês em Anápolis. Sushi fresco, sabores autênticos e delivery rápido.
            </p>
            
            {/* Social Links */}
            <div className="flex gap-4">
              <a
                href={restaurantInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center text-white hover:bg-amber-700 transition-colors"
                aria-label="Instagram do Japamix"
              >
                <Instagram size={20} aria-hidden="true" />
              </a>
              <a
                href={`https://wa.me/${restaurantInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center text-white hover:bg-green-600 transition-colors"
                aria-label="WhatsApp do Japamix"
              >
                <MessageCircle size={20} aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Links rápidos">
            <h4 className="text-white font-semibold text-lg mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href, link.external)}
                    className="text-white/60 hover:text-amber-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="text-amber-600 mt-1 flex-shrink-0" size={18} aria-hidden="true" />
                <div>
                  <p className="text-white/60">Telefone</p>
                  <a href={`tel:${restaurantInfo.phone}`} className="text-white hover:text-amber-400 transition-colors">
                    {restaurantInfo.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MessageCircle className="text-green-500 mt-1 flex-shrink-0" size={18} aria-hidden="true" />
                <div>
                  <p className="text-white/60">WhatsApp Restaurante</p>
                  <a
                    href={`https://wa.me/${restaurantInfo.whatsapp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:text-amber-400 transition-colors"
                  >
                    (62) 99530-4210
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="text-amber-500 mt-1 flex-shrink-0" size={18} aria-hidden="true" />
                <address className="not-italic">
                  <p className="text-white/60">Endereço</p>
                  <p className="text-white">
                    {restaurantInfo.address.street}<br/>
                    {restaurantInfo.address.neighborhood}<br/>
                    {restaurantInfo.address.city} - {restaurantInfo.address.state}
                  </p>
                </address>
              </li>
            </ul>
          </div>

          {/* Hours Summary */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">Horários</h4>
            <div className="bg-white/5 rounded-xl p-4">
              <div className="flex items-center gap-3 mb-3">
                <Clock className="text-amber-500" size={20} aria-hidden="true" />
                <span className="text-white font-medium">Todos os dias</span>
              </div>
              <p className="text-2xl font-bold text-amber-500">18h às 23h</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-sm text-center md:text-left">
            © {currentYear} JAPAMIX Anápolis – Todos os direitos reservados
          </p>
          <p className="text-white/50 text-sm flex items-center gap-1">
            Feito com <Heart size={14} className="text-amber-600" aria-hidden="true" /> em Anápolis - GO
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
